import checkIcon from "../../../assets/createGroup.png";
import AddUser from "../../../assets/addPerticipant.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function GroupCreation() {
  const { t } = useTranslation();

  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I create a Crowdfunding group?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step1")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step2")}
          {"  "}
          <img src={checkIcon} alt="icon" className="inline-flex w-16" />{" "}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step4")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 5: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step5")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 6: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step6")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 7: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step7.part1")}
          <img src={AddUser} alt="icon" className="inline-flex w-12" />{" "}
          {t("helpCenter.Crowdfunding.groupCreation.step7.part2")}
        </p>
        <p>
          <span className="font-semibold">Step 8: </span>
          {t("helpCenter.Crowdfunding.groupCreation.step8.part1")}
          {t("helpCenter.Crowdfunding.groupCreation.step8.part2")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default GroupCreation;
